/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DocumentDownloadUrlResponse interface.
 */
export function instanceOfDocumentDownloadUrlResponse(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    return true;
}
export function DocumentDownloadUrlResponseFromJSON(json) {
    return DocumentDownloadUrlResponseFromJSONTyped(json, false);
}
export function DocumentDownloadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'expiresIn': json['expiresIn'],
        'fileName': json['fileName'],
    };
}
export function DocumentDownloadUrlResponseToJSON(json) {
    return DocumentDownloadUrlResponseToJSONTyped(json, false);
}
export function DocumentDownloadUrlResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'expiresIn': value['expiresIn'],
        'fileName': value['fileName'],
    };
}
